import React from 'react'

import { FormattedMessage } from 'react-intl'

import { HeaderComponent } from 'components/block/HeaderComponent'
import { ContainerSvg } from 'components/page/Profile/ProfileHeader/ProfileHeader.styled'
import { settingsModalPath } from 'components/paths'
import { EdnaUnreadMessageCount } from 'components/presentational/Badge/EdnaUnreadMessageCount'
import { RouterLink } from 'components/presentational/link'
import { GearWheelSvg } from 'components/presentational/svg/GearWheelSvg'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useLayoutContext } from 'hooks/useLayoutContext'

export const ProfileHeader = () => {
  const { baseUrl } = useLayoutContext()
  return (
    <HeaderComponent
      settings={
        <ContainerSvg>
          <RouterLink
            to={mergeAllUrls(baseUrl, settingsModalPath)}
            data-name="link-main-settings-action"
          >
            <EdnaUnreadMessageCount>
              <GearWheelSvg />
            </EdnaUnreadMessageCount>
          </RouterLink>
        </ContainerSvg>
      }
    >
      <FormattedMessage id="profile.title" />
    </HeaderComponent>
  )
}
